import { AnalyticsService } from "@common-services/analytics-service";
import { useMemo } from "react";

export function useAnalyticsService() {
  return useMemo(() => new AnalyticsService(), []);
}
